import React, { useState } from 'react';
import '../components/styles/specialgallery.css';

const SpecialGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      id: 1,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 1",
      category: "Wedding"
    },
    {
      id: 2,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 2",
      category: "Glam"
    },
    {
      id: 3,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 3",
      category: "Editorial"
    },
    {
      id: 4,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 4",
      category: "Wedding"
    },
    {
      id: 5,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 5",
      category: "Glam"
    },
    {
      id: 6,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 6",
      category: "Editorial"
    },
    {
      id: 7,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 7",
      category: "Wedding"
    },
    {
      id: 8,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 8",
      category: "Glam"
    },
    {
      id: 9,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 9",
      category: "Editorial"
    },
    {
      id: 10,
      src: "/api/placeholder/400/300",
      alt: "Makeup Portfolio 10",
      category: "Wedding"
    }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">Portfolio Gallery</h2>
      
      <div className="gallery-grid">
        {images.map((image) => (
          <div 
            key={image.id} 
            className="gallery-item"
            onClick={() => openModal(image)}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="gallery-image"
            />
            <div className="gallery-overlay">
              <p className="category-label">
                {image.category}
              </p>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content">
            <button
              className="modal-close"
              onClick={closeModal}
              aria-label="Close modal"
            >
              ×
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="modal-image"
              onClick={(e) => e.stopPropagation()}
            />
            <div className="modal-caption">
              {selectedImage.category}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpecialGallery;